module.exports = __webpack_public_path__ + "static/media/9DESA28.c2b6ca25.jpg";